/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import React from 'react';
import i18n from '../../i18n/AdHocBundle.properties';

interface IAdHocMessageProps {
    title?: string
    message?: string
}

const Component = (props: IAdHocMessageProps) => {

    const { title, message } = props;

    return (
        <div className="jr-mOverlay jr-mOverlayLight jr-mOverlayClear jr jr-jEmptyMessage">
            <div className="jr-mOverlay-wrapper jr-mOverlay-wrapperCenter jr">
                <div className="jr-mMessage jr-mMessageInfo jr-mMessagePlain jr">
                    <div className="jr-mMessage-textContainer jr">
                        <p className="jr-mMessage-title jr">{title}</p>
                        <p className="jr-mMessage-text jr">{message}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

Component.defaultProps = {
    title: i18n['adhoc.data.is.empty.title'],
    message: i18n['adhoc.data.is.empty.text']
}

export default Component;
